var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59326 12.3265V5.55315C5.59326 5.28649 5.67326 5.02649 5.81993 4.80649L7.63993 2.09982C7.92659 1.66649 8.63993 1.35982 9.24659 1.58649C9.89993 1.80649 10.3333 2.53982 10.1933 3.19315L9.8466 5.37315C9.81993 5.57315 9.87326 5.75315 9.98659 5.89315C10.0999 6.01982 10.2666 6.09982 10.4466 6.09982H13.1866C13.7133 6.09982 14.1666 6.31315 14.4333 6.68649C14.6866 7.04649 14.7333 7.51315 14.5666 7.98649L12.9266 12.9798C12.7199 13.8065 11.8199 14.4798 10.9266 14.4798H8.32659C7.87993 14.4798 7.25326 14.3265 6.96659 14.0398L6.11326 13.3798C5.78659 13.1332 5.59326 12.7398 5.59326 12.3265Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4735 4.25342H2.78683C1.7535 4.25342 1.3335 4.65342 1.3335 5.64008V12.3468C1.3335 13.3334 1.7535 13.7334 2.78683 13.7334H3.4735C4.50683 13.7334 4.92683 13.3334 4.92683 12.3468V5.64008C4.92683 4.65342 4.50683 4.25342 3.4735 4.25342Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledlike);
export default __webpack_public_path__ + "static/media/filledlike.8828446b99d779bf17fa99291496b247.svg";
export { ForwardRef as ReactComponent };